if (!customElements.get('product-modal')) {
    customElements.define(
      'product-modal',
      class ProductModal extends ModalDialog {
        constructor() {
          super();
          this.prevButton = this.querySelector('[id^="ModalPrevButton-"]');
          this.nextButton = this.querySelector('[id^="ModalNextButton-"]');

          if (this.prevButton && this.nextButton) {
            this.prevButton.addEventListener('pointerdown', (event) => {
              event.stopPropagation();
              // We still want the button to visually react like a click for default browser behavior if needed,
              // but the main action is here.
            });
            this.prevButton.addEventListener('click', (event) => {
              // Stop propagation again in case click fires separately and bubbles
              event.stopPropagation(); 
              this.changeMedia('prev');
            });

            this.nextButton.addEventListener('pointerdown', (event) => {
              event.stopPropagation();
            });
            this.nextButton.addEventListener('click', (event) => {
              event.stopPropagation();
              this.changeMedia('next');
            });
          }
        }
  
        hide() {
          console.log('[ProductModal] hide() called. Current activeMediaId:', this.dataset.activeMediaId, 'Opener:', this.openedBy);
          super.hide();
        }
  
        show(opener) {
          super.show(opener);
          const activeMediaId = opener.getAttribute('data-media-id');
          if (activeMediaId) {
            this.dataset.activeMediaId = activeMediaId; 
          }
          this.mediaItems = Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
          this.showActiveMedia();
          this.updateNavButtonStates();
        }

        updateNavButtonStates() {
          if (!this.prevButton || !this.nextButton || !this.mediaItems || this.mediaItems.length <= 1) {
            this.prevButton?.style.setProperty('display', 'none');
            this.nextButton?.style.setProperty('display', 'none');
            return;
          }
          this.prevButton.style.display = 'flex'; // or 'block' depending on exact styling
          this.nextButton.style.display = 'flex'; // or 'block'
        }

        changeMedia(direction) {
          if (!this.mediaItems || this.mediaItems.length <= 1) return;

          const currentMediaId = this.dataset.activeMediaId;
          let currentIndex = this.mediaItems.findIndex(item => item.dataset.mediaId === currentMediaId);

          if (currentIndex === -1) { // Should not happen if modal opened correctly
            console.warn('Could not find current active media in list for navigation.');
            currentIndex = 0;
          } 

          let newIndex;
          if (direction === 'next') {
            newIndex = (currentIndex + 1) % this.mediaItems.length;
          } else {
            newIndex = (currentIndex - 1 + this.mediaItems.length) % this.mediaItems.length;
          }

          const newMediaTarget = this.mediaItems[newIndex];
          if (newMediaTarget) {
            this.dataset.activeMediaId = newMediaTarget.dataset.mediaId;
            this.showActiveMedia();
            // this.updateNavButtonStates(); // Not strictly needed here as visibility doesn't change per slide

            // Dispatch event for description handler
            this.dispatchEvent(new CustomEvent('activemediaupdated', {
              bubbles: true,
              detail: { activeMediaId: this.dataset.activeMediaId }
            }));
          }
        }
  
        showActiveMedia() {
          const targetMediaId = this.dataset.activeMediaId;
          if (!targetMediaId) return;

          this.querySelectorAll('.product-media-modal__content > [data-media-id]').forEach((mediaElement) => {
            if (mediaElement.getAttribute('data-media-id') === targetMediaId) {
              mediaElement.classList.add('active');
              mediaElement.style.display = ''; 
              
              const mediaTemplate = mediaElement.querySelector('template');
              const mediaContent = mediaTemplate ? mediaTemplate.content : null;
              if (
                mediaElement.nodeName === 'DEFERRED-MEDIA' &&
                mediaContent && 
                mediaContent.querySelector('.js-youtube') 
              ) {
                mediaElement.loadContent();
              }
            } else {
              mediaElement.classList.remove('active');
              mediaElement.style.display = 'none';
            }
          });
        }
      }
    );
  }
  